import { z } from 'zod';
import { monthlyDeficitSchema } from './missing-posts';

export const criticalIssuesWindowSchema = z.object({
  count: z.number(),
  fromDate: z.string(),
  toDate: z.string(),
});
export type CriticalIssuesWindowSchema = z.infer<typeof criticalIssuesWindowSchema>;

export const criticalIssuesSchema = z.object({
  missingPosts: criticalIssuesWindowSchema,
  unfinishedPosts: criticalIssuesWindowSchema,
  monthlyDeficits: z.array(monthlyDeficitSchema),
});
export type CriticalIssuesSchema = z.infer<typeof criticalIssuesSchema>;
